import React from 'react';

import i18n from 'I18n';

import ActivityLoginReachLimitContent from 'component/records/ActivityLoginReachLimitContent';

import './ReachLimitDetailMobile.scss';

const ReachLimitDetailMobile = ({ match }) => {
  const activityLogId = match?.params?.id;
  return (
    <div className="activity-log-reach-limit-container">
      <div className="activity-log-reach-limit-content">
        <div className="reach-limit-head">
          <div className="title1 headline">
            {i18n.t('records:reward_limit_reached')}
          </div>
        </div>
      </div>
      <ActivityLoginReachLimitContent activityLogId={activityLogId} />
    </div>
  );
};

export default ReachLimitDetailMobile;
